<script>
import PagesDisplay from "@/components/PagesDisplay";

export default {
  components: {
    PagesDisplay,
  },
};
</script>

<template>
  <PagesDisplay page-type="faq" :title="$t('views.faq')" />
</template>
